export const HOME_PAGE_SLUGS = {
  ALL: {
    en: 'all',
    es: 'todas',
    pt: 'tudo',
  },
  JOB: {
    en: 'jobs',
    es: 'empleos',
    pt: 'empregos',
  },
  INTERNSHIP: {
    en: 'internships',
    es: 'pasantias',
    pt: 'estagios',
  },
  VOLOP: {
    en: 'volunteer',
    es: 'voluntariado',
    pt: 'voluntariado',
  },
  ORG: {
    en: 'organizations',
    es: 'organizaciones',
    pt: 'organizacoes',
  },
  BLOG: {
    en: 'blog',
    es: 'blog',
    pt: 'blog',
  },
} as const;
